import * as actionTypes from './ManufacturerActionType';

const initialState = {
  searchManufacturerObj: {},
  maintainManufacturerObj: {},
  manufacturerList: [],
  manufacturerFilterByGovList: [],
  manufacturerFilterByComList: [],
  MFGLabelerList: [],
  labelerUsingMFG: {},
  selectManufacturerData: {},
  labelersList: [],
  contractList: [],
  bankruptcyList: [],
  searchLabelerList: [],
  manufacturerDetailsList: [],
  contact: null,
  saveOrUpdateMessage: '',
  allContactTypeDropDown: [],
  existingContactDetails: [],
  contactDetails: [],
  updateOrSaveContactDetailsMessage: '',
  generalSystemParameter: [],
  contractUsingContactData: [],
  getAllDropdownValues: [],
  allClientGroupList: [],
  allClientGroupPlanList: [],
  allClientListData: [],
  allContractListData: [],
  allProviderListData: [],
  getAllExistingContactList: [],
  providerApiCancelSources: [], // Array to store multiple cancel sources
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_MANUFACTURER_TAB_DATA:
      return { ...state, searchManufacturerObj: action.searchManufacturerObj };
    case actionTypes.MAINTAIN_MANUFACTURER_TAB_DATA:
      return {
        ...state,
        maintainManufacturerObj: action.maintainManufacturerObj,
      };
    case actionTypes.GET_ALL_MANUFACTURERS:
      return { ...state, manufacturerList: action.manufacturerList };
    case actionTypes.GET_ALL_MANUFACTURER_SEARCH_BY_G:
      return {
        ...state,
        manufacturerFilterByGovList: action.manufacturerFilterByGovList,
      };
    case actionTypes.GET_ALL_MANUFACTURER_SEARCH_BY_C:
      return {
        ...state,
        manufacturerFilterByComList: action.manufacturerFilterByComList,
      };
    case actionTypes.GET_ALL_MFG_LABELERS:
      return { ...state, MFGLabelerList: action.MFGLabelerList };
    case actionTypes.GET_ALL_MFG_CONTRACTS:
      return { ...state, contractList: action.contractList };
    case actionTypes.GET_ALL_MANUFACTURER_DETAILS_ACTION_TYPE:
      return {
        ...state,
        manufacturerDetailsList: action.manufacturerDetailsList,
      };
    case actionTypes.GET_LABELER_USING_MANUFACTURES:
      return { ...state, labelerUsingMFG: action.labelerUsingMFG };
    case actionTypes.SELECT_DATA_MANUFACTURER:
      return {
        ...state,
        selectManufacturerData: action.selectManufacturerData,
      };
    case actionTypes.SAVE_OR_UPDATE:
      return { ...state, saveOrUpdateMessage: action.saveOrUpdateMessage };

    case actionTypes.MAINTAIN_LABELER_DATA_ACTION_TYPES:
      return { ...state, labelersList: action.payload };
    case actionTypes.MAINTAIN_BANKRUPTCY_DATA_ACTION_TYPES:
      return { ...state, bankruptcyList: action.payload };
    case actionTypes.SEARCH_LABELER_POPUP_DATA_ACTION_TYPES:
      return { ...state, searchLabelerList: action.searchLabelerList };

    case actionTypes.GET_CONTACT_TYPE:
      return {
        ...state,
        allContactTypeDropDown: action.allContactTypeDropDown,
      };
    case actionTypes.GET_EXISTING_CONTACT_DETAILS_MFG:
      return {
        ...state,
        existingContactDetails: action.existingContactDetails,
      };
    case actionTypes.GET_CONTACT_DETAILS:
      return { ...state, contactDetails: action.contactDetails };
    case actionTypes.CONTRACT_USING_CONTACT_TYPE:
      return {
        ...state,
        contractUsingContactData: action.contractUsingContactData,
      };
    case actionTypes.UPDATE_CONTACT_DETAILS:
      return {
        ...state,
        updateOrSaveContactDetailsMessage:
          action.updateOrSaveContactDetailsMessage,
      };
    case actionTypes.GET_GENERAL_SYSTEM_PARAMETER: {
      return {
        ...state,
        generalSystemParameter: action.generalSystemParameter,
      };
    }
    case actionTypes.COPY_CONTACT_GET_CLIENT_CODE_VALUES:
      return { ...state, getAllDropdownValues: action.getAllDropdownValues };
    case actionTypes.GET_ALL_CLIENT_GROUP_FOR_COPY_CONTACT:
      return { ...state, allClientGroupList: action.allClientGroupList };
    case actionTypes.GET_ALL_CLIENT_GROUP_PLAN_FOR_COPY_CONTACT:
      return {
        ...state,
        allClientGroupPlanList: action.allClientGroupPlanList,
      };
    case actionTypes.GET_ALL_CLIENT_FOR_COPY_CONTACT:
      return { ...state, allClientListData: action.allClientListData };
    case actionTypes.GET_ALL_CONTRACT_FOR_COPY_CONTACT:
      return { ...state, allContractListData: action.allContractListData };
    case actionTypes.GET_ALL_PROVIDER_FOR_COPY_CONTACT:
      return { ...state, allProviderListData: action.allProviderListData };
    case actionTypes.GET_EXISTING_CONTACT_DETAILS_FOR_COPY_CONTACT:
      return {
        ...state,
        getAllExistingContactList: action.getAllExistingContactList,
      };
    case actionTypes.ADD_PROVIDER_API_CANCEL_SOURCE:
      return {
        ...state,
        providerApiCancelSources: [...state.providerApiCancelSources, action.cancelSource],
      };
    case actionTypes.CLEAR_PROVIDER_API_CANCEL_SOURCES:
      return {
        ...state,
        providerApiCancelSources: [],
      };

    default:
      return state;
  }
};
export default reducer;
